import * as endpoints from '../apiUtils/endpoints';
import { api } from '../apiUtils/api';
import { CreateLeadBody, PriceQuoteRequest, PriceQuoteResponse, WidgetResponse } from './widget.types';

export const widgetApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getWidgetDataByAppointmentGroups: builder.query<WidgetResponse, string | undefined>({
      query: (appointmentGroupId) => ({
        url: `${endpoints.appointmentGroups}/${appointmentGroupId}/${endpoints.widget}`,
      }),
    }),
    getPriceQuote: builder.query<PriceQuoteResponse, PriceQuoteRequest>({
      query: (body) => ({
        url: endpoints.pricingQuote,
        method: 'POST',
        body,
      }),
      providesTags: ['PriceQuote'],
      keepUnusedDataFor: 60,
    }),
    pay: builder.mutation<unknown, CreateLeadBody>({
      query: (dataForPay) => ({
        url: endpoints.lead,
        method: 'POST',
        body: dataForPay,
      }),
      invalidatesTags: ['PriceQuote'],
      async onQueryStarted(_, { queryFulfilled }) {
        await queryFulfilled;
      },
    }),
    getClientSecret: builder.mutation<{ client_secret: string }, string>({
      query: (token) => ({
        url: `${process.env.REACT_APP_BACKEND_URL}client/setup-intent`,
        method: 'POST',
        body: { token },
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        await queryFulfilled;
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetWidgetDataByAppointmentGroupsQuery,
  useGetPriceQuoteQuery,
  usePayMutation,
  useGetClientSecretMutation,
} = widgetApi;
